import { getInput } from './get-input.js';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const focusInput = /* @__PURE__ */ __name((frame) => {
  var _a;
  (_a = getInput(frame)) == null ? void 0 : _a.focus();
}, "focusInput");

export { focusInput };
//# sourceMappingURL=focus-input.js.map
